import { forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import { resolveBaseAppearance } from './theme';
import type { BaseAspectRatioProps } from './types';
import { cn } from './utils';

function resolveAspectRatio(value: number) {
  if (!Number.isFinite(value) || value <= 0) {
    throw new RangeError('BaseAspectRatio ratio must be a positive finite number.');
  }
  return String(value);
}

export const BaseAspectRatio = forwardRef<
  HTMLDivElement,
  BaseAspectRatioProps
>(function BaseAspectRatio(
  {
    children,
    ratio = 16 / 9,
    appearance,
    className,
    classNames,
    style,
    ...aspectRatioProps
  },
  ref,
) {
  const resolvedAppearance = useMonkeysBaseAppearance(appearance);
  const componentAttributes = useMonkeysComponentAttributes();
  const theme = resolveBaseAppearance(resolvedAppearance);

  return (
    <div
      {...componentAttributes}
      {...aspectRatioProps}
      ref={ref}
      data-monkeys-component="aspect-ratio"
      data-slot="root"
      data-ratio={ratio}
      className={cn(theme.slots.aspectRatioRoot, classNames?.root, className)}
      style={{
        ...theme.styles.aspectRatio,
        aspectRatio: resolveAspectRatio(ratio),
        ...style,
      }}
    >
      {children}
    </div>
  );
});
